import { EventCodes } from '../../../../../App/model/event-codes';

(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxViewLink', {
		bindings: {
			active: '<',
			view: '<',
			showDetails: '<',
			onClick: '<',
			onTabChanged: '&',
		},
		controller: MxViewLink,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-view-link/mx-view-link.html',
	});

	MxViewLink.$inject = ['$scope', 'mx.shell.EventService', 'mx.app.ColorService', 'mx.app.ThemeService'];

	function MxViewLink($scope, eventService, colorService, themeService) {
		var vm = this;

		vm.$onInit = function () {
			if (!vm.view) {
				return;
			}

			setBorderColor();

			if (vm.view.isWizard) {
				Object.defineProperty(vm, 'tabs', {
					get: function () {
						return (
							(vm.view.locals.wizard &&
								(vm.view.locals.wizard.allWizardSteps || []).sort(function (step1, step2) {
									return step1.orderNum - step2.orderNum < 0 ? -1 : step1.orderNum === step2.orderNum ? 0 : 1;
								})) ||
							[]
						);
					},
				});

				Object.defineProperty(vm, 'currentTab', {
					get: function () {
						return vm.tabs[vm.view.locals.wizard.currentStep];
					},
				});
			} else {
				vm.onTabClick = function (tab) {
					eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
						eventName: 'Dialog tab switched',
						view: vm.view,
						propsModifier: (props) => ({
							...props,
							sender: `${props.sender}_${tab.Id}`,
							senderTitle: `${props.senderTitle}_${tab.Key}`,
						}),
					});

					vm.view.selectedTab = tab;
					vm.onTabChanged({ tab: tab });
				};
				vm.isClickable = true;

				Object.defineProperty(vm, 'tabs', {
					get: function () {
						return vm.view.tabs;
					},
				});

				Object.defineProperty(vm, 'currentTab', {
					get: function () {
						return vm.view.selectedTab;
					},
				});

				Object.defineProperty(vm, 'edited', {
					get: function () {
						return vm.view.opened && vm.view.dialogType !== mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
					},
				});
			}
		};

		eventService.subscribeTo(mx.shell.EventCodes.ThemeChanged, setBorderColor, $scope);

		async function setBorderColor() {
			let viewColor = vm.view.headerColor;
			const theme = await themeService.getCurrentTheme();
			vm.borderColor = mx.isEnhancedColorContrastMode ? colorService.enhanceColorContrast(viewColor, theme['body-bg-color'], 3.3) : viewColor;
		}

		return vm;
	}
})();
